import { type AxiosInstance } from 'axios'
import moment from 'moment'

type CreateSubscriptionData = {
  title: string
  multiple_companies: string
  sources: string
  locations: string
  pollutants: string
  integrations: string
  labels?: boolean
  manual_entry?: boolean
  bulk_upload?: boolean
  audit_log?: boolean
  disclosure_reports: string
  price?: string
  is_default?: boolean
}
type UpdateSubscriptionData = CreateSubscriptionData

export default (axios: AxiosInstance) => ({
  list() {
    return axios.get('/v1/subscriptions/')
  },
  create(data: CreateSubscriptionData) {
    return axios.post('/v1/subscriptions/', data)
  },
  update(id: number, data: UpdateSubscriptionData) {
    return axios.put(`/v1/subscriptions/${id}/`, data)
  },
  tenantTiers() {
    const tenantId = localStorage.getItem('tenant')
    return axios.get(`/v1/tenants/organization_subscriptions/${tenantId}`)
  },
  async listTierFeatures() {
    const {
      data: [tenantTier],
    } = await this.tenantTiers()
    const { expires_in, subscription } = tenantTier
    const { data: allTiers } = await this.list()

    // Find the tier the user is in, if it has expired select the free tier
    const subscriptionHasExpired = -1 * moment().diff(expires_in, 'days') <= 0
    const allocatedTierTitle = subscriptionHasExpired
      ? 'free'
      : subscription.title.toLowerCase()

    return allTiers.find(
      ({ title }: { title: string }) =>
        title.toLowerCase() === allocatedTierTitle,
    )
  },
  async checkLimit(resource: string, currentResourceCount = 0) {
    const tierFeatures = await this.listTierFeatures()
    let limit = tierFeatures[resource]

    if (typeof limit === 'boolean') {
      return limit
    }
    const booleanStringIsTrue
      = ['multiple_companies', 'integrations', 'disclosure_reports'].includes(
        resource,
      ) && limit === '1'
    if (
      ['pollutants', 'disclosure_reports'].includes(resource)
      || limit.toLowerCase().includes('more than')
      || booleanStringIsTrue
    ) {
      return true
    }
    if (limit.toLowerCase().includes('less than')) {
      limit = Number(limit.match(/\d+/)[0]) - 1
    }
    if (typeof limit === 'string') {
      limit = Number(limit.match(/\d+/)?.[0])
    }

    return currentResourceCount < limit
  },
  async checkLimitMultiple(resources: Array<string>) {
    const tierFeatures = await this.listTierFeatures()
    return [...resources].map((resource) => {
      const limit = tierFeatures[resource]
      // if (typeof limit === 'boolean')
      return limit
      // TODO for other data types
    })
  },
})
